import React from 'react';
import { Form, Input, Button, notification } from 'antd';
import './styles.login.scss';
import { useNavigate } from 'react-router-dom';
import { apiUser } from '../../api/user';


const LoginForm = () => {

    const [form] = Form.useForm();
    const navigate = useNavigate();

    const onFinish = async (values: any) => {
        console.log('Received values:', values);

        const req = {
            username: values.username,
            password: values.password
        }
        console.log(req);

        await apiUser.login(req)
            .then((res) => {
                console.log(res.data.data);

                const user = res.data.data.user;

                localStorage.setItem('username', user.username);
                localStorage.setItem('userId', user.id);
                localStorage.setItem('token', res.data.data.accessToken);
                notification.success({
                    message: 'Đăng nhập thành công',
                });

                if (user.role === 'Trưởng phòng') {
                    localStorage.setItem('role', 'admin');
                    navigate('/expert-management');
                }
                else if (user.role === 'superadmin') {
                    localStorage.setItem('role', 'superadmin');
                    navigate('/user-management');
                }
                else {
                    localStorage.setItem('role', 'user');
                    navigate('/expert-management');
                };

            })
            .catch((err) => {
                console.log(err);

                if (err?.response?.data?.message === 'User not found') {
                    notification.error({
                        message: 'Tên đăng nhập không tồn tại',
                        description: 'Vui lòng kiểm tra lại tên đăng nhập ',
                    });
                }

                if (err?.response?.data?.message === 'Invalid password') {
                    notification.error({
                        message: 'Mật khẩu không chính xác',
                        description: 'Vui lòng kiểm tra lại mật khẩu',
                    });
                }
            });

        // setIsLogin(true);
    };


    return (
        <div className='main-login'>
            <div className="main-login-container">
                <div className="main-login-container-left">
                    <h1>Đăng nhập</h1>
                    <Form
                        name="loginForm"
                        onFinish={onFinish}
                        initialValues={{
                            remember: true,
                        }}
                        form={form}
                        layout='vertical'
                        className='form-login'
                    >
                        <Form.Item
                            label="Tên đăng nhập"
                            name="username"
                            className='form-item'
                            rules={[
                                {
                                    required: true,
                                    message: "Vui lòng nhập tên đăng nhập!"
                                },
                            ]}
                        >
                            <Input placeholder="Nhập tên đăng nhập của bạn" />
                        </Form.Item>

                        <Form.Item
                            label="Mật khẩu"
                            name="password"
                            className='form-item'
                            rules={[
                                {
                                    required: true,
                                    message: "Vui lòng nhập mật khẩu!"
                                },
                            ]}
                        >
                            <Input 
                                type="password"
                                placeholder="Nhập mật khẩu của bạn"
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button type="primary" htmlType="submit">
                                Đăng nhập
                            </Button>
                        </Form.Item>

                        {/* <Form.Item>
                            <Button type="link" onClick={handleClickResetPassword}>
                                Đặt lại mật khẩu
                            </Button>
                        </Form.Item> */}
                    </Form>
                </div>
            </div>
        </div>

    );
};

export default LoginForm;